import { IResult } from '../data/data';

export enum StatusType {
  READY = 'READY',
  NORESULTS = 'NORESULTS',
  FETCHING = 'FETCHING',
  ERROR = 'ERROR'
}

export interface IStatus {
  type: StatusType;
  statusMessage?: string;
}

export interface IPagination {
  page: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface IEnv {
  nonce: string;
  wpAjaxAdminUrl: string;
  props: IEnvProps;
}

export interface IEnvProps {
  resource?: string;
  pageSize?: string;
  home?: string;
}

/**
 * Redux internal state store
 */
export interface IContentBySearchState {
  items: IResult[];
  pagination: IPagination;
  status?: IStatus;
  query?: string;
  env?: IEnv;
}
